import { CompassCardUI } from '@scale/compass-ui/types';
import {
  CdsUploadCardShared,
  CdsUploadSchemaType,
  type CdsUploadContext,
  CDS_UPLOAD,
} from '@scale/genai-compass-shared/cards/cds_upload';
import { faFileUpload } from '@fortawesome/pro-solid-svg-icons';
import CdsUploadCardComponent from './CdsUploadCardComponent';

const DefaultCdsUploadContext: CdsUploadContext = {
  cardType: CDS_UPLOAD,
};

export const CdsUploadCardInfo: CompassCardUI<CdsUploadSchemaType> = {
  ...CdsUploadCardShared,
  title: 'CDS Upload',
  icon: 'file-upload',
  toolTip: 'Upload Google Drive files or external images to CDS.',
  defaultContext: DefaultCdsUploadContext,
  ownerTeam: 'Connectivity',
  showOutput: true,
  button: {
    title: 'Upload to CDS',
    icon: faFileUpload,
  },
  legacyComponent: CdsUploadCardComponent,
};
